import React from 'react';
import bootbox from 'bootbox';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import UserRoute from './UserRoute';
import Home from '../Home/Home';
import { Analytics } from '../Analytics';
import Login from '../Login/Login';
import PrivacyPolicy from '../Navbar/PrivacyPolicy';
import TermsAndConditions from '../Navbar/Terms&Conditions';
import Verify from '../Verify';
import CourseMain from '../Home/CourseMain';
import CourseSelect from '../Home/CourseSelect';
import Landing from '../Home/Landing';
import LiscenseExam from '../Home/LiscenseExam';
import Module from './Module';

function RoutesController() {
  const handleLocationChange = (m, callback) => {
    bootbox.confirm({
      size: 'small',
      title: "You're quiting. Are you sure?",
      message: m,
      callback: function (result) {
        callback(result);
      },
    });
  };

  return (
    <>
      <Router getUserConfirmation={(m, callback) => handleLocationChange(m, callback)}>
        <Switch>
          <UserRoute exact path="/">
            <Home />
          </UserRoute>
          <UserRoute exact path="/a/:userId">
            <Analytics />
          </UserRoute>

          <Route path={`/login/`}>
            <Login />
          </Route>
          <Route path={`/privacy-policy/`}>
            <PrivacyPolicy />
          </Route>
          <Route path={`/terms-and-conditions/`}>
            <TermsAndConditions />
          </Route>
          <Route path={`/verify/`}>
            <Verify />
          </Route>
          <Route path={`/courseMain`}>
            <CourseMain />
          </Route>
          <Route path={`/courseSelect/`}>
            <CourseSelect />
          </Route>
          <Route path={`/landing/`}>
            <Landing />
          </Route>
          <Route path={`/liscenseExam/`}>
            <LiscenseExam />
          </Route>
          <UserRoute path="/:moduleId">
            <Module />
          </UserRoute>
          <Route path={'*'}>
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default RoutesController;
